import React from "react";
import styled, { css } from "styled-components";

// shared styles
import { regular, medium } from "core/fontStyles";
import colors from "core/colors";
import breakpoints from "core/breakpoints";
import Flexbox from "core/Flexbox";
import BodyText from "core/BodyText";
import { convertPxToRem } from "frontend/components/helpers";

import { getLinkElementStyles } from "core/Link/styles";

export const RadioButtonLabel = styled.label`
    cursor: pointer;
    margin-top: 1.5rem;
    display: flex;
    align-items: flex-start;
`;

export const DescriptionContainer = styled.div`
    margin-left: ${convertPxToRem({ px: 16 })};
    flex: 2.5 1;
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        max-width: ${convertPxToRem({ px: 155 })};
    }
`;

export const DescriptionHeading = styled.h3`
    ${regular}
    font-size: ${convertPxToRem({ px: 15 })};
    line-height: ${convertPxToRem({ px: 24 })};;
    margin-bottom: ${convertPxToRem({ px: 6 })};
    color: ${colors.secondary.orca};
`;

export const DescriptionText = styled.p`
    ${medium}
    font-size: ${convertPxToRem({ px: 13 })};
    line-height: ${convertPxToRem({ px: 18 })};
    color: ${colors.secondary.oolong};

    a {
        ${getLinkElementStyles({
            styleType: "primary",
            size: "sm"
        })}
    }
`;

export const PriceWrapper = styled(Flexbox).attrs({
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-end"
})`
    flex: 1 1;
    align-items: flex-start;
`;

export const PriceContainer = styled.p`
    ${medium};
    color: ${colors.secondary.orca};
    font-size: ${convertPxToRem({ px: 18 })};
    line-height: 1;

    @media (max-width: ${breakpoints.tablet.rem}) {
        font-size: ${convertPxToRem({ px: 16 })};
    }
`;

export const PriceSubText = styled(BodyText).attrs({
    size: "sm",
    copyColor: colors.secondary.oolong
})``;
